import { toast } from '@gitbook/spine-react';

import { shortcuts, useKeyboardShortcuts } from '../../../Keyboard';

/**
 * Displays a toast indicating that changes are auto-saved when the user tries to save via the
 * keyboard shortcut (mod + s).
 */
export function useAutoSaveToast() {
    useKeyboardShortcuts(
        {
            [shortcuts.EDITOR_SAVE]: (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();

                toast.info('Changes are auto-saved, you don’t need to save manually');
            },
        },
        ['editor-selection-collapsed', 'editor-selection-expanded']
    );
}
